import * as React from 'react';
import { IgcCardMediaComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * A container component for card media content such as images, GIFs, or videos.
 * This component should be used within an igc-card element to display visual content.
 * @slot  - Renders the card media content (e.g., img, video elements).
 * @class
 */
export const IgrCardMedia = /* @__PURE__ */ createComponent({
  tagName: 'igc-card-media',
  displayName: 'IgrCardMedia',
  elementClass: Component,
  react: React,
});

export type IgrCardMedia = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrCardMediaModule = Component;
